import createSupabaseStore from './supabase-table-store'

export default (projectId, playerId, mapId) => createSupabaseStore(
  async (set, supabase, payload) => {
    const {data} = await supabase
      .from('project_scores_attempts_view')
      .select('*')
      .eq('project_id', projectId)
      .eq('player_id', playerId)
      .eq('map_id', mapId)
      .order('attempt_num', {ascending: true})
    ;

    set(data);
  },
  ['scores'],
  []
)